import { ScrollView, View } from 'react-native';
import React, { FC, useMemo } from 'react';
import { MyAccountLayoutProps } from './MyAccountLayout.types';
import PagePath from '../PagePath';
import AccountMenu from '../AccountMenu/AccountMenu';
import { Footer } from '../Footer';
import { Image } from '../Image';
import { STYLE_VARS } from '../../constants/style-vars';
import { Text } from '../Text';
import PageTitle from '../PageTitle';
import { NavigationService } from '../../services/navigation';

const MyAccountLayout: FC<MyAccountLayoutProps> = ({
  children,
  current,
  title,
  icon,
}) => {
  const pathSteps = useMemo(() => {
    return [
      {
        name: 'Member area',
        onPress: () => {
          NavigationService.push('Root', {
            screen: 'HomeTab',
          });
        },
      },
      {
        name: 'My account',
      },
      {
        name: title,
      },
    ];
  }, [title]);

  return (
    <ScrollView showsVerticalScrollIndicator={false}>
      <View
        style={{
          maxWidth: 1250,
          width: '90%',
          marginHorizontal: 'auto',
          marginTop: 10,
        }}
      >
        <PagePath pathSteps={pathSteps} />
        <View
          style={{
            flexDirection: 'row',
            alignItems: 'flex-start',
            justifyContent: 'space-between',
            marginVertical: 30,
          }}
        >
          <AccountMenu current={current} />
          <View style={{ width: '75%' }}>
            <PageTitle icon={icon} title={title} />
            {children}
          </View>
        </View>
      </View>
      <Footer />
    </ScrollView>
  );
};

export default MyAccountLayout;
